@use '../../../../scss/settings/colors';

.modal_container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); // Fondo oscuro semi-transparente
  z-index: 1000
  
}

.button_container {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 0.75rem;
}

.coupon_button {
  display: flex;
  justify-content: center;
  margin-bottom: 1.5rem;
}
